module.exports = __webpack_public_path__ + "img/BeiOpaGibtsEis.dd5d43f5.jpg";